import { GoButton } from '@imago/api-client-for-react'
import { Hello } from "../Hello.tsx"
import { ImagoCare } from '../Care.tsx'
import { useCare, useOver18 } from '../../api.ts'

export function Community({fullScreen}: {fullScreen?: boolean}) {
	const care = useCare()
	const over18 = useOver18()

	if (care === undefined || over18 === undefined) return

	const Section = fullScreen ? 'main' : 'div'
	const H = fullScreen ? 'h1' : 'h2'

	return <Section>
		{fullScreen ? <Hello/> : <></>}
		<section>
			<H>The Butterflies’ Sanctuary</H>
			<p><strong>The Butterflies’ Sanctuary</strong> is our Discord community to give you - the Imago members - opportunity to socialize and to reduce the isolation that we as trans people frequently face.</p>
			{!over18 ? <p>We’re sorry - right now it's available only for 18+ people.</p> : <>
				<p><strong>We’re waiting to meet you.</strong></p>
				<GoButton className="primary" href={'https://discord.gg/2Jfr4aJQbH'} target="_blank" disabledBecause={!care.nextCharge ? "Subscribe to Imago Care first." : undefined}>Join us</GoButton>
			</>}
		</section>
		{!over18 ? <></> : <>
			<hr></hr>
			<section>
				{!care.nextCharge
					? <p><strong>For security reasons - we let only our members access the community server. Please subscribe first:</strong></p>
					: <p>For security reasons - we let only our members access the community server. This is the status of your subscription:</p>
				}
				<ImagoCare/>
			</section>
		</>}
	</Section>
}
